import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const StatusBadge = ({ status, cssClassName }) => {
	const statusConfigMap = (status = '') => {
		switch (status.toUpperCase()) {
			case 'PENDING':
			case 'CHALLENGE':
			case 'PENDING APPROVAL':
			case 'REVIEWED':
				return {
					cssClasses: 'u-background-color-status-pending u-color-white',
					label: 'Awaiting Authorisation',
				};
			default:
				return {
					cssClasses: '',
					label: status,
				};
		}
	};

	const statusConfig = statusConfigMap(status);

	const classes = classnames('c-a-badge-label c-a-badge-label--rounded', statusConfig.cssClasses, cssClassName);

	return <span className={classes}>{statusConfig.label}</span>;
};

StatusBadge.propTypes = {
	status: PropTypes.string.isRequired,
	cssClassName: PropTypes.string,
};

export default StatusBadge;
